export enum SocialPlatformEnum {
    TWITTER = 'TWITTER',
    FACEBOOK = 'FACEBOOK',
    INSTAGRAM = 'INSTAGRAM',
    LINKEDIN = 'LINKEDIN',
    REDDIT = 'REDDIT',
}
export enum SocialInfoTypeEnum {
    POST = 'POST',
    COMMENT = 'COMMENT',
}